"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Attachment_exports = {};
__export(Attachment_exports, {
  default: () => Attachment_default
});
module.exports = __toCommonJS(Attachment_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.332 3.39453L4.42578 12.2617C3.8138 12.8867 3.50781 13.6354 3.50781 14.5078C3.50781 15.3802 3.8138 16.1224 4.42578 16.7344C5.05078 17.3594 5.79948 17.6719 6.67188 17.6719C7.55729 17.6719 8.3125 17.3594 8.9375 16.7344L15.2656 10.4453C15.3568 10.3411 15.474 10.2891 15.6172 10.2891C15.7604 10.2891 15.8776 10.3411 15.9688 10.4453C16.0599 10.5365 16.1055 10.6536 16.1055 10.7969C16.1055 10.9271 16.0599 11.0443 15.9688 11.1484L9.64062 17.457C9.23698 17.8607 8.77474 18.1602 8.25391 18.3555C7.74609 18.5638 7.21875 18.668 6.67188 18.668C6.13802 18.668 5.61719 18.5638 5.10938 18.3555C4.60156 18.1602 4.13932 17.8607 3.72266 17.457C3.31901 17.0404 3.01302 16.5781 2.80469 16.0703C2.59635 15.5625 2.49219 15.0417 2.49219 14.5078C2.49219 13.974 2.59635 13.4466 2.80469 12.9258C3.01302 12.418 3.31901 11.9622 3.72266 11.5586L12.6289 2.69141C13.2018 2.11849 13.8919 1.83203 14.6992 1.83203C15.5195 1.83203 16.2227 2.11849 16.8086 2.69141C17.3815 3.26432 17.668 3.96094 17.668 4.78125C17.668 5.58854 17.3815 6.27865 16.8086 6.85156L7.90234 15.7188C7.5638 16.0573 7.15365 16.2266 6.67188 16.2266C6.20312 16.2266 5.79948 16.0573 5.46094 15.7188C5.1224 15.3802 4.95312 14.9766 4.95312 14.5078C4.95312 14.026 5.1224 13.6159 5.46094 13.2773L13.7812 4.99609C13.8724 4.90495 13.9896 4.85938 14.1328 4.85938C14.276 4.85938 14.3932 4.90495 14.4844 4.99609C14.5885 5.10026 14.6406 5.22396 14.6406 5.36719C14.6406 5.4974 14.5885 5.60807 14.4844 5.69922L6.16406 14C6.02083 14.1302 5.94922 14.2995 5.94922 14.5078C5.94922 14.7031 6.02083 14.8724 6.16406 15.0156C6.30729 15.1589 6.47656 15.2305 6.67188 15.2305C6.88021 15.2305 7.05599 15.1589 7.19922 15.0156L13.332 3.39453ZM7.19922 15.0156L16.0859 6.14844C16.4766 5.77083 16.6719 5.3151 16.6719 4.78125C16.6719 4.2474 16.4766 3.78516 16.0859 3.39453C15.7083 3.01693 15.2461 2.82812 14.6992 2.82812C14.1654 2.82812 13.7096 3.01693 13.332 3.39453L7.19922 15.0156Z",
      fill: "currentColor"
    }
  )
);
const SvgAttachment = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Attachment_default = SvgAttachment;
